const revealText = {

    elements: {},

    wrapTextInSpans(element) 
    {
        const content = element.innerText;
        const words = content.split(' ');
        const lines = [];
        let lineIndex = 0;
        let lineContent = '';
        
        element.setAttribute('data-content', element.innerHTML);

        element.innerHTML = '|';
        let height = element.offsetHeight;
        element.innerHTML = '';

        words.forEach( word => {
            lineContent += word + ' ';
            element.innerText = lineContent;

            const offsetHeight = element.offsetHeight;

            if( offsetHeight > height )
            {
                lineIndex += 1;
                height = offsetHeight;
            }

            if( !lines[lineIndex] ) lines[lineIndex] = [];
            lines[lineIndex].push(word);
        });

        const spans = lines.map( (line, index) => '<span>' + lines[index].join(' ') + '</span> ');
        element.innerHTML = spans.join(' ');

        return lines.length;
    },

    unwrapText()
    {
        this.elements.forEach( element => {
            element.classList.remove('reveal-text');
            const content = element.getAttribute('data-content');
            if( content )
            {
                //element.style.lineHeight = .9;
                element.innerHTML = content;
            }
        });

        window.removeEventListener('resize', this.unwrapText.bind(this) );
    },

    cacheDom() 
    {
        this.elements = document.querySelectorAll('.js-reveal-text');
    },

    bind() 
    {
        //return;
        if( this.elements )
        {
            this.elements.forEach( element => {
                const lineCount = this.wrapTextInSpans( element );
                element.classList.remove('js-reveal-text');
                element.classList.add('reveal-text');

                // set "reveal-text-complete" class after animation is complete
                // that will be 1s + 1/3s per line
                const delay = 1000 + (333 * lineCount);
                setTimeout( () => {
                    element.classList.add('reveal-text-complete');
                }, delay );
            });

            window.addEventListener('resize', () => { this.unwrapText() } );
        }
    },

    init()
    {
        window.addEventListener('fontLoaded', () => {
            this.cacheDom();
            this.bind();
        });
    }
    
}

export default revealText;